import React from 'react'
import ModalOverlay from '../../../../UI/ModalOverlay/ModalOverlay.tsx'
import styles from '../DocumentInsightProceedWarnModal.module.scss'

type Props = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  busy?: boolean
}

const RubroMetricRemoveWarnModal: React.FC<Props> = ({ open, onCancel, onConfirm, busy = false }) => {
  return (
    <ModalOverlay isOpen={open} onClose={onCancel} zIndex={40}>
      <div className={styles.box} role="dialog" aria-modal="true" aria-labelledby="rubro-metric-remove-title">
        <h2 id="rubro-metric-remove-title" className={styles.title}>
          Quitar cómputo métrico
        </h2>
        <p className={styles.body}>
          La planilla de cotización que generamos para este rubro depende de ese cómputo. Si la quitás, esa
          planilla no se adjuntará al publicar.
        </p>
        <p className={styles.body}>
          Podés cargar tu propio cómputo (grilla o páginas del documento) y guardar el borrador. Para obtener una
          planilla de cotización nueva acorde a tu cómputo, incluí ese material en la documentación del rubro y
          volvé a analizar el proyecto.
        </p>
        <p className={styles.body}>
          Si preferís conservar la planilla generada, cancelá o restaurá el cómputo original después de quitar.
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={onCancel} disabled={busy}>
            Cancelar
          </button>
          <button type="button" className={styles.primary} onClick={onConfirm} disabled={busy}>
            Quitar cómputo
          </button>
        </div>
      </div>
    </ModalOverlay>
  )
}

export default RubroMetricRemoveWarnModal
